<h4 class="title-filter mb-2" *ngIf="name">{{ name |enumText: 'FilterOptionsEnum' }}</h4>

<ng-container *ngIf="option.type == 'VALUE'">
  <div class="mb-4" [id]="'select' + name">
    <div class="custom-multi-select" dropdown #multiDropdown="bs-dropdown" #multiDropdownContainer [autoClose]="true"
      [insideClick]="true" placement="bottom left" container="body">

      <!-- Cabeçalho do select (campo clicável) -->
      <div class="select-display" dropdownToggle>
        <div class="left">
          <i class="fas fa-search fa-lg icon-search"></i>

          <div class="tags-selected" [id]="'tags-selected' + name">
            <!-- Tags selecionadas -->
            <div *ngFor="let elementId of selectedList" class="item-selected">
              <h4 class="mr-2 item-text">
                {{ isValueKeyId(elementId) }}
              </h4>
              <i (click)="removeOptionFilter(elementId); $event.stopPropagation()"
                class="fas fa-xmark cursor-pointer"></i>
            </div>

            <!-- Placeholder quando não tem nada selecionado -->
            <span *ngIf="!selectedList.length" class="placeholder">
              Selecione
            </span>
          </div>
        </div>

        <div class="right">
          <span *ngIf="countPlus > 0" class="count-plus-label">
            + {{ countPlus }}
          </span>
          <i class="fas fa-chevron-down caret"></i>
        </div>
      </div>

      <!-- Dropdown de opções -->
      <div *dropdownMenu class="select-menu" role="menu" [style.width.px]="dropdownWidth"
        [style.minWidth.px]="dropdownWidth">
        <button type="button" class="select-menu-item" *ngFor="let item of option.optionList"
          (click)="toggleOption(item.id); $event.stopPropagation()">
          <span class="select-menu-item-text">{{ isValueKeyId(item.id) }}</span>
          <i *ngIf="selectedList.includes(item.id)" class="fas fa-check already-selected"></i>
        </button>

      </div>

    </div>
  </div>
</ng-container>

<ng-container *ngIf="option.type == 'TEXT'">
  <div class="mb-4">
    <div class="text-values-selected mb-2">
      <div class="tags-selected">
        <div *ngFor="let elementId of selectedList" class="item-selected">
          <h4 class="mr-2 item-text">
            {{ isValueKeyId(elementId) }}
          </h4>
          <i (click)="removeOptionFilter(elementId)" class="fas fa-xmark cursor-pointer"></i>
        </div>

        <span *ngIf="!selectedList.length" class="placeholder">
          Informe um ou mais IDs
        </span>
      </div>
    </div>

    <div class="text-values-input-row">
      <input
        class="filter-search"
        [(ngModel)]="textInputValue"
        (keydown)="onTextInputKeydown($event)"
        placeholder="Digite IDs separados por vírgula, espaço ou JSON"
      />

      <button type="button" class="btn btn-primary" (click)="addTextValues()">
        Adicionar
      </button>
    </div>
  </div>
</ng-container>


<!-- Intervalo de tempo -->
<ng-container *ngIf="option.type == 'DATE'" class="form-group d-flex align-items-center">
  <div class="pl-0 mb-4">
    <input type="text" placeholder="Selecione a data" class="form-control" bsDaterangepicker [bsConfig]="{
          isAnimated: true,
            containerClass: 'theme-dark-blue',
            dateInputFormat: 'DD-MM-YYYY',
            showWeekNumbers: false
          }" [bsValue]="selectedList" (bsValueChange)="addOptionFilter($event, true)" />
  </div>
</ng-container>
<!-- Intervalo de tempo -->

<ng-container *ngIf="option.type == 'ADDRESS'" class="form-group d-flex align-items-center">
  <!-- Input de Pesquisa de Endereço do Filtro -->
  <div class="btn-group w-100 mb-4" dropdown #dropdown="bs-dropdown" container="body" placement="bottom right">
    <input dropdownToggle class="filter-search" (keyup.enter)="searchAddress($event); dropdown.show()"
      [autocomplete]="true" placeholder="Pesquisar no mapa" id="inputFilterSearch" [(ngModel)]="inputFilterSearch" />
    <div *dropdownMenu role="menu">
      <div *ngIf="filterSearch.length" class="dropdown-search-filter" style="top: 8px; right: 0px">
        <div *ngFor="let result of filterSearch" class="dropdownItem" role="menuitem"
          (click)="filterAddressSearch(result)" (alt)="(result.name)">
          {{ result.name }}
        </div>
      </div>
    </div>
    <button *ngIf="filterSearch.length" type="button" class="close close-search" (click)="eraseFilterSearch()"
      aria-label="Close">
      <i aria-hidden="true" class="fas fa-xmark"></i>
    </button>
  </div>
  <!-- Input de Pesquisa de Endereço do Filtro -->
</ng-container>
<!-- INPUT DAS OPÇÕES DE FILTRO, ASSIM QUE ADICIONADAS -->
